module.exports = __webpack_public_path__ + "img/star3.867fd3d1.png";